import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { takeWhile } from "rxjs/operators";
import { RxStompState } from "@stomp/rx-stomp";

import {
    FvmsCommonService
    ,FvmsApiDtgWsProcessorService
} from "src/app/shared/service";
import {
    FilterSecToTime
    ,FilterDist
    ,FilterVolt
} from "src/app/shared/filter";

@Component({
    selector: "car-realtime-card"
    ,templateUrl: "./car.realtime.card.component.html"
    ,styleUrls: ["./car.realtime.card.component.scss"]
    ,providers: [FilterSecToTime,FilterDist,FilterVolt]
})
export class CarRealtimeCardComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    unitId:string;
    lastItem:any;
    subscriptionPacketLogProcess:any;
    connectionStateMessageProcess:string = "접속 해제";
    connectionStateMessageClassProcess:string = "btn-secondary";
    dtgDriverNm:string;
    dtgGpsAddr:string;
    dtgSpeed:any;
    dtgBatteryVolt:any;
    dtgDistDaily:any;
    dtgDistAccumul:any;

    constructor(
        private fvmsApiDtgWsProcessorService:FvmsApiDtgWsProcessorService
    ) {}

    ngOnInit() {
        this.fvmsApiDtgWsProcessorService.connect()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((state) => {
                console.log("fvmsApiDtgWsProcessorService","status",RxStompState[state]);
                switch(state){
                    case RxStompState.OPEN:
                        this.connectionStateMessageProcess = "접속 완료";
                        this.connectionStateMessageClassProcess = "btn-success";
                        break;
                    case RxStompState.CONNECTING:
                        this.connectionStateMessageProcess = "접속중";
                        this.connectionStateMessageClassProcess = "btn-info";
                        break;
                    case RxStompState.CLOSING:
                        this.connectionStateMessageProcess = "접속 해제중";
                        this.connectionStateMessageClassProcess = "btn-warning";
                        break;
                    case RxStompState.CLOSED:
                    default:
                        this.connectionStateMessageProcess = "접속 해제";
                        this.connectionStateMessageClassProcess = "btn-secondary";
                        break;
                }
            });
        
        this.subscriptionPacketLogProcess = this.fvmsApiDtgWsProcessorService.subscribePacketLog()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((message) => {
                let packet = JSON.parse(message.body);
                // console.log("fvmsApiDtgWsProcessorService","subscribePacketLog",packet);
                let head = packet.dataHead;
                if(head && head.unitId){
                    // console.log("fvmsApiDtgWsProcessorService","subscribePacketLog","head",head,this.unitId,head.unitId);
                    if(this.unitId === head.unitId){
                        // console.log("fvmsApiDtgWsProcessorService","subscribePacketLog","unitId",head.unitId);
                        if(packet.listBody){
                            let listBody = packet.listBody;
                            let listSize = listBody.length;
                            this.lastItem = listBody[listSize - 1];
                            // console.log("fvmsApiDtgWsProcessorService","subscribePacketLog","lastItem",lastItem);

                            this.dtgDriverNm = head.dtgDriverNm;
                            this.dtgGpsAddr = this.lastItem.gpsAddr;
                            this.dtgSpeed = this.lastItem.speed;
                            this.dtgBatteryVolt = this.lastItem.batteryVolt;
                            this.dtgDistDaily = this.lastItem.distDaily;
                            this.dtgDistAccumul = this.lastItem.distAccumul;
                        }
                    }
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
        this.fvmsApiDtgWsProcessorService.disconnect();
    }

    ngAfterViewInit() {
        
    }

    @Input()
    set inputUnitId(unitId:string){
        // console.log("inputUnitId",unitId);
        if(unitId){
            this.unitId = unitId;
        }
    }
}